import type { UserDetails, UserDetailsPasswordService, UserDetailsService } from './types.ts';

export class MapUserDetailsService implements UserDetailsService, UserDetailsPasswordService {
    readonly #users = new Map<string, UserDetails>();

    constructor(...users: UserDetails[]) {
        for (const user of users) {
            this.#users.set(this.#getKey(user.username), user);
        }
    }

    async findByUsername(username: string): Promise<UserDetails | undefined> {
        const key = this.#getKey(username);
        const result = this.#users.get(key);
        return result !== undefined ? { ...(result) } : undefined;
    }

    async updatePassword(user: UserDetails, newPassword?: string): Promise<UserDetails> {
        const userDetails = { ...(user), password: newPassword };
        // what if user does not exist?
        if (userDetails) {
            const key = this.#getKey(user.username);
            this.#users.set(key, userDetails);
        }
        return userDetails;
    }

    #getKey(username: string) {
        return username.toLowerCase();
    }
}
